import client from './client'

export default {
  async topicInfo (tid) {
    const url = `/v2/topic/info/${tid}`
    const res = await client.get(url)
    return res && res.data && res.data.data
  },
  async getCommentsById (tid, page = 1, limit = 20) {
    const url = `/v3/topic/${tid}/comments`
    const res = await client.get(url, {
      params: {
        limit,
        page
      }
    })
    return res.data.data
  },
 async getChoseCommentsById (tid) {
    const url = `/v3/topic/${tid}/comments/chosen`
    const res = await client.get(url)
    return res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/topic.js